import { FC, useEffect } from "react";
import Dialog, { DialogTitle, DialogContent } from "@/components/Dialog";
import Typography from "@/components/Typography";
import Button from "@/components/Button";
import { useTrackers } from "@/hooks";
import styles from "./TimeLockDialog.module.scss";

type Props = {
  onClose: () => void;
};

const TimeLockDialog: FC<Props> = ({ onClose }) => {
  const { track } = useTrackers();

  useEffect(() => {
    track("Job Locked Time Dialog Opened", {
      eventId: "job-locked-time-dialog-opened",
    });
  }, []);

  const handleClose = () => {
    track("Job Locked Time Clicked", {
      eventId: "job-locked-time-clicked",
    });
    onClose();
  };

  return (
    <Dialog
      open
      classes={{ paper: styles.paper }}
      BackdropProps={{
        classes: { root: styles.backdrop },
      }}
    >
      <DialogTitle hasCloseButton={false}>Unlocking soon</DialogTitle>
      <DialogContent className={styles.content}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={"/images/jobs-coordinator-lock.svg"}
          alt="icon"
          className={styles.image}
        />
        <Typography variant="h6" className={styles.title}>
          Coming soon!
        </Typography>
        {/* <Typography variant="h6">Get ready for exclusive access</Typography> */}
        <Typography
          color="text.secondary"
          variant="body1"
          className={styles.description}
        >
          Congratulations - you&apos;re well on your way to starting your
          adventure with Global! Access to the Global-exclusive Job Board will
          be unlocked closer to your trip&apos;s start date.
        </Typography>
        <Button onClick={onClose} className={styles.button}>
          Great
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default TimeLockDialog;
